import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CommonBreadcrumbsModule } from '@capital-access/common/breadcrumbs';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { CommonRouterModule } from '@capital-access/common/router';
import { Breadcrumbs } from './breadcrumb';
import { PENDO_SCOPE } from './constant';
import { pendoNavigationGuard } from './guards/pendo-navigation.guard';
import { PendoEffects } from './pendo.effects';
import { PendoService } from './pendo.service';
import { PendoPortalPageComponent } from './pendo-portal-page.component';

export function pendoInitializer(pendoService: PendoService) {
  return pendoService.insertPendoAgentScript();
}

@NgModule({
  imports: [
    CommonModule,
    CommonRouterModule.forFeature({
      authorized: [{ path: 'pendo-portal', component: PendoPortalPageComponent, canActivate: [pendoNavigationGuard] }]
    }),
    EffectsModule.forFeature([PendoEffects]),
    CommonLocalizationModule.forFeature(PENDO_SCOPE),
    CommonBreadcrumbsModule.forFeature(Breadcrumbs)
  ],
  providers: [
    PendoService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: pendoInitializer,
      deps: [PendoService]
    }
  ]
})
export class PendoModule {}
